<section class="my-dashboard-area">
  <div class="container">
    <div class="myDashboard-profile">
      <div class="row align-items-center">
        <div class="col-lg-4 col-md-5">
          <div class="profile-image">
            <img alt="image" src="{{student.profileImgUrl || 'assets/img/profile.png'}}">
          </div>
        </div>

        <div class="col-lg-8 col-md-7">
          <div class="profile-content">
            <h3>{{student.name}} {{student.surname}}</h3>
            <ul class="contact-info">
              <li><i class='bx bx-envelope'></i> <a>{{student.email || student.name + '@gmail.com'}}</a></li>
              <li><i class='bx bx-phone'></i> <a>{{student.phone}}</a></li>
            </ul>
            <ul class="social">
              <li><a class="d-block" href="https://www.facebook.com/" target="_blank"><i
                class='bx bxl-facebook'></i></a></li>
              <li><a class="d-block" href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
              <li><a class="d-block" href="https://www.instagram.com/" target="_blank"><i class='bx bxl-instagram'></i></a>
              </li>
              <li><a class="d-block" href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="myDashboard-navigation">
      <ul>
        <li><a (click)="toggleEditor('course')" [ngClass]="{'active' : showCourseTab}">
          <i class='bx bxs-dashboard'></i>Курсы</a>
        </li>
        <li><a (click)="toggleEditor('tests')" [ngClass]="{'active' : showTestsTab}">
          <i class='bx bx-detail'></i>Тесты</a>
        </li>
        <li><a (click)="toggleEditor('account')" [ngClass]="{'active' : showAccountTab}">
          <i class='bx bx-edit'></i>Аккаунт</a>
        </li>
        <li><a (click)="logOut()"><i class='bx bx-log-out'></i>Выйти</a></li>
      </ul>
    </div>

    <div *ngIf="showCourseTab">
      <div class="myDashboard-content">
        <div class="recent-orders-table table-responsive">
          <table class="table">
            <thead>
            <tr>
              <th>#</th>
              <th>Название</th>
              <th>Открыто до</th>
              <th>Цена</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of student.availableCourses; let i=index">
              <td class="centered"><b>{{i + 1}}</b></td>
              <td>{{item.course.title}}</td>
              <td>{{item.expireDate | date: 'dd/MM/yyyy HH:MM'}}</td>
              <td>{{item.course.price}} сом</td>
              <td><a [routerLink]="['/courses/', item.course._id]" class="view-button">Посмотреть</a></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div *ngIf="showTestsTab">
      <div class="myDashboard-content">
        <div class="recent-orders-table table-responsive">
          <table class="table">
            <thead>
            <tr>
              <th>#</th>
              <th>Название</th>
              <th>Цена</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of student.availableSubjectTests; let i=index">
              <td class="centered"><b>{{i + 1}}</b></td>
              <td>{{item.test.title}}</td>
              <td>{{item.test.price}} сом</td>
              <td><a (click)="viewTest(item)" class="view-button" data-target="#test"
                     data-toggle="modal">Результаты</a></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div *ngIf="showAccountTab">
      <div class="container">

        <div class="myDashboard-content">
          <form class="edit-account">
            <div class="row">
              <div class="col-lg-6 col-md-6">
                <div class="form-group">
                  <label>Имя <span class="required">*</span></label>
                  <input [(ngModel)]="student.name" class="form-control" name="firstName" type="text">
                </div>
              </div>

              <div class="col-lg-6 col-md-6">
                <div class="form-group">
                  <label>Фамилия <span class="required">*</span></label>
                  <input [(ngModel)]="student.surname" class="form-control" name="lastName" type="text">
                </div>
              </div>

              <div class="col-lg-6 col-md-6">
                <div class="form-group">
                  <label>Email</label>
                  <input [(ngModel)]="student.email" class="form-control" name="email" type="email">
                </div>
              </div>

              <div class="col-lg-6 col-md-6">
                <div class="form-group">
                  <label>Тел. <span class="required">*</span></label>
                  <input [(ngModel)]="student.phone" class="form-control" disabled name="phone" type="phone">
                </div>
              </div>

              <div class="img">
                <h1>Фото профиля</h1>
                <div class="avatar-upload">
                  <div class="avatar-edit">
                    <input (change)="uploadFile($event)"
                           accept=".png, .jpg, .jpeg, .svg" id="imageUpload" type='file'/>
                    <label for="imageUpload"></label>
                  </div>
                  <div class="avatar-preview">
                    <div id="imagePreview"
                         style="background-image: url({{student.profileImgUrl || 'assets/img/profile.png'}});">
                    </div>
                  </div>

                </div>
              </div>

              <div class="col-lg-12 col-md-12">
                <button (click)="saveChanges()" class="default-btn" type="submit"><i
                  class='bx bx-save icon-arrow before'></i><span
                  class="label">Сохранить</span><i class="bx bx-save icon-arrow after"></i></button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</section>


<div aria-labelledby="myModalLabel" class="modal fade text-selection-none" id="test" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel">{{selectedSubjectTest?.test?.title}}</h4>
        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
          <span aria-hidden="true" style="font-size: 45px; font-weight: 300;"> &times;
          </span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngFor="let item of selectedTestResult; let i=index" class="card" style="width: 18rem;">
          <ul class="card-body">
            <div>
              <h2>
                <span style="font-size: 20px; color:#4757e9; font-weight: 600;">Попытки : </span>
                <span style="font-size: 25px; color:#173117;font-weight: 700;">{{i + 1}}</span>
              </h2>
            </div>
            <div>
              <h2>
                <span style="font-size: 20px; color:#4757e9; font-weight: 600;">Правильно : </span>
                <span style="font-size: 25px; color:green;font-weight: 700;">{{item.correctAnswers}}</span>
              </h2>
            </div>
            <div>
              <h2>
                <span style="font-size: 20px; color:#4757e9; font-weight: 600;">Не правильно : </span>
                <span style="font-size: 25px; color:red;font-weight: 700;">{{item.wrongAnswers}}</span>
              </h2>
            </div>
            <div>
              <h2>
                <span style="font-size: 20px; color:#4757e9; font-weight: 600;">Балл : </span>
                <span style="font-size: 25px;font-weight: 700;">{{item.points}}</span>
              </h2>
            </div>
          </ul>
        </div>
      </div>
      <div class="modal-footer">
        <div class="buttons-2 d-flex">
          <button
            class="btn btn-outline-danger btn-rounded btn-md ml-4"
            data-dismiss="modal"
            type="button">Закрыть
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
